export const BOOST_ENABLED = import.meta.env?.VITE_FEATURE_BOOST === 'true';
